export const SYSTEM_NAME = "interfaces";
export const PAGE_VIEW_EVENT = "web_analytics.tracking.page_view.PageViewEvent";
export const BUILDER_INTERACTION_EVENT =
  "platform.interfaces.web_analytics.InterfaceBuilderInteractionEvent";
export const CONSUMER_INTERACTION_EVENT =
  "platform.interfaces.web_analytics.InterfaceConsumerInteractionEvent";
export const CHATBOT_INTERACTION_EVENT =
  "platform.interfaces.web_analytics.InterfaceChatbotAITokenUsageReceivedEvent";
